// src/services/userService.js
import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

/**
 * User Service
 * Handles all API operations related to users (waiters, staff, etc.)
 */
export const userService = {
  /**
   * Get all users
   * @returns {Promise} List of all users
   */
  getAllUsers: async () => {
    try {
      const response = await apiClient.get(ENDPOINTS.USERS.GET_ALL);
      return response;
    } catch (error) {
      console.error('Failed to fetch users:', error);
      throw error;
    }
  },

  /**
   * Get user by ID
   * @param {string} userId - User ID
   * @returns {Promise} User object
   */
  getUserById: async (userId) => {
    try {
      const response = await apiClient.get(ENDPOINTS.USERS.GET_BY_ID(userId));
      return response;
    } catch (error) {
      console.error(`Failed to fetch user ${userId}:`, error);
      throw error;
    }
  },

  /**
   * Get users filtered by role name (e.g., 'WAITER', 'MANAGER')
   * @param {string} roleName - Role name to filter by
   * @returns {Promise} List of users with that role
   */
 getUsersByRole: async (roleName) => {
   try {
     const response = await apiClient.get(`/user/by-role/${roleName}`);


     console.log(" WAITER LIST:", response);
     console.log("IS ARRAY:", Array.isArray(response));

     return Array.isArray(response) ? response : [];
   } catch (err) {
     console.error("Failed to fetch users by role", err);
     return [];
   }
 },



 getWaiters: async () => {
   return userService.getUsersByRole("WAITER");
 },

  /**
   * Get users filtered by department name
   * @param {string} departmentName - Department name to filter by
   * @returns {Promise} List of users in that department
   */
  getUsersByDepartment: async (departmentName) => {
    try {
      const response = await apiClient.get(ENDPOINTS.USERS.FILTER, {
        params: { departmentName }
      });
      return response;
    } catch (error) {
      console.error(`Failed to fetch users in department ${departmentName}:`, error);
      throw error;
    }
  },

  /**
   * Get all waiters (convenience method)
   * Currently fetches all users - filter can be added later
   * @returns {Promise} List of all users (to be filtered for WAITER role later)
   */
  // getWaiters: async () => {
  //   // TODO: Change to getUsersByRole('WAITER') once filter is implemented
  //   return userService.getAllUsers();
  // },

  /**
   * Create a new user
   * @param {Object} userData - User data
   * @returns {Promise} Created user
   */
  createUser: async (userData) => {
    try {
      const response = await apiClient.post(ENDPOINTS.USERS.CREATE, userData);
      return response;
    } catch (error) {
      console.error('Failed to create user:', error);
      throw error;
    }
  },

  /**
   * Update a user
   * @param {string} userId - User ID
   * @param {Object} userData - Updated user data
   * @returns {Promise} Updated user
   */
  updateUser: async (userId, userData) => {
    try {
      const response = await apiClient.put(ENDPOINTS.USERS.UPDATE(userId), userData);
      return response;
    } catch (error) {
      console.error(`Failed to update user ${userId}:`, error);
      throw error;
    }
  },

  /**
   * Delete a user
   * @param {string} userId - User ID
   * @returns {Promise} Deletion result
   */
  deleteUser: async (userId) => {
    try {
      const response = await apiClient.delete(ENDPOINTS.USERS.DELETE(userId));
      return response;
    } catch (error) {
      console.error(`Failed to delete user ${userId}:`, error);
      throw error;
    }
  },

  /**
   * Update user preferences
   * @param {string} userId - User ID
   * @param {Object} preferences - Preferences data
   * @returns {Promise} Update result
   */
  updatePreferences: async (userId, preferences) => {
    try {
      const response = await apiClient.patch(
        ENDPOINTS.USERS.UPDATE_PREFERENCE(userId),
        preferences
      );
      return response;
    } catch (error) {
      console.error(`Failed to update preferences for user ${userId}:`, error);
      throw error;
    }
  },
};

export default userService;
